import React from 'react';
import Button from '@alifd/next/lib/button';
import axios from 'axios';
import { DownloadButtonProps } from './types';

const DownloadButton: React.FC<DownloadButtonProps> = ({
  headers = {
    authorization: localStorage.getItem('feathers-jwt'),
  },
  params,
  url,
  fileName,
  responseFileType,
  buttonProps,
  children,
}) => {
  const download = async () => {
    try {
      const res = await axios.get(url, {
        headers,
        params,
        responseType: responseFileType,
      });
      const link = document.createElement('a');
      
      if (responseFileType === 'json') {
        link.href = res.data.filePath;
      }
      let blob = new Blob();
      if (responseFileType === 'blob') {
        blob = new Blob([res.data]);
        link.href = URL.createObjectURL(blob);
      }

      const headerFileName: string = decodeURI(
        res.headers['content-disposition']?.split('filename=')[1]
      );

      link.download = fileName || headerFileName;
      link.click();
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <Button
      {...{
        ...buttonProps,
        onClick: download,
      }}
    >
      {children}
    </Button>
  );
};

export default DownloadButton;
